import api from "./api";

const medicationRequestService = {};
const endpoint = "/medication-requests";

medicationRequestService.create = function (requestData) {
  return api.post(endpoint, requestData).then(({ data }) => data);
};

medicationRequestService.get = function (query = {}) {
  return api.get(endpoint, { params: query }).then(({ data }) => data);
};

medicationRequestService.update = function (id, updateData) {
  return api.put(`${endpoint}/${id}`, updateData).then(({ data }) => data);
};

export default medicationRequestService;
